/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

/** @module components/product-color */
import baustein from "baustein";
import analytics from "../analytics/analytics";
import productClickMixin from "./mixins/product-click-mixin";

/**
 * A product color or variant of a canonical product.
 *
 * @constructor
 * @alias module:components/product-color
 * @extends module:baustein
 */
export default baustein.register(
    "product-color",
    /** @lends module:components/product-color.prototype */
    {
        mixins: [productClickMixin],

        defaultOptions: {
            overlayEnabled: false,
            productUid: null,
            productSlug: null,
            reason: null
        },

        async sendAnalytics() {
            await analytics.event("navigation", "color-picker");
        },

        getClickOverlayClasses: function() {
            return [".product-color__link"];
        }
    }
);

